var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBacktestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.4208C0 11.4409 0.794367 10.6465 1.77427 10.6465H23.5801C24.56 10.6465 25.3543 11.4409 25.3543 12.4208V34.2266C25.3543 35.2065 24.56 36.0009 23.5801 36.0009C10.5529 36.0009 0 25.4479 0 12.4208ZM3.62595 14.195C4.47202 23.846 12.1548 31.5288 21.8058 32.3749V14.195H3.62595Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8066 1.77427C21.8066 0.794367 22.601 0 23.5809 0C36.6081 0 47.161 10.5529 47.161 23.5801C47.161 24.56 46.3666 25.3544 45.3867 25.3544H23.5809C22.601 25.3544 21.8066 24.56 21.8066 23.5801V1.77427ZM25.3552 3.62595V21.8058H43.535C42.689 12.1549 35.0062 4.47202 25.3552 3.62595Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktestIcon);
export default __webpack_public_path__ + "static/media/backtest_icon.15388454b5b68b27ecaa71faede20eee.svg";
export { ForwardRef as ReactComponent };